import { Box, Collapse, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { memo, PropsWithChildren, ReactElement, useState } from 'react';
import styles from './Filter.module.scss';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

export interface FilterListItemProps extends PropsWithChildren {
  displayName: string;
}

export const FilterListItem = memo(function ({ displayName, children }: FilterListItemProps): ReactElement {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

  return (
    <>
      <ListItem disablePadding sx={{ width: '90%', margin: '0 auto' }}>
        <ListItemButton onClick={() => setIsCollapsed(!isCollapsed)}>
          {isCollapsed ? <ExpandMore /> : <ExpandLess />}
          <ListItemText primary={displayName} sx={{ paddingLeft: '8px' }} />
        </ListItemButton>
      </ListItem>
      <Collapse in={!isCollapsed} unmountOnExit>
        <Box
          className={`${styles.flex_container} ${styles.flex_vertical} ${styles.flex_container_width} ${styles.flex_container_height} ${styles.centered}`}
        >
          {children}
        </Box>
      </Collapse>
    </>
  );
});
